import type { ReactNode } from "react"
import { Toast } from "@base-ui/react/toast"

import type { IconSpec } from "@/components/icons/icon"

export type ToastData = {
  icon?: IconSpec
  leading?: ReactNode
}

export const toastManager = Toast.createToastManager<ToastData>()
